const SESSION_DURATION_MS = 24 * 60 * 60 * 1000;

export function saveAuthSession(token, user, userId) {
  const expiresAt = Date.now() + SESSION_DURATION_MS;
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem('userId', userId);
  localStorage.setItem('authExpiresAt', String(expiresAt));
}

export function getStoredAuth() {
  const token = localStorage.getItem('token');
  const authExpiresAt = Number(localStorage.getItem('authExpiresAt') || 0);

  if (!token || !authExpiresAt || Date.now() > authExpiresAt) {
    clearAuthSession();
    return { token: null, user: null, userId: null };
  }

  return {
    token,
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    userId: localStorage.getItem('userId')
  };
}

export function clearAuthSession() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('userId');
  localStorage.removeItem('authExpiresAt');
}
